<template>
	<div>
		<ModalHeader :title="getString('vat_nature_regulations_btn')" :button-text="getString('apply')" @click-button="apply" />
		<AppList :items="items" />
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppList from "@/shared/components/AppList.vue";
import {useLanguageStore} from "@/shared/stores";
import {useEpsonStore, useMenuStore, useUserStore} from "@/console-new/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let epsonStore = useEpsonStore();
		let menuStore = useMenuStore();
		let userStore = useUserStore();
		return {getString: languageStore.getString, epsonStore, menuStore, userStore};
	},
	name: "VatNatureBottomSheet",
	components: {ModalHeader, AppList},
	emits: ["apply"],
	props: {
		nature: {
			type: String,
			required: true
		},
		regRefIndex: {
			type: Number,
			required: true,
		}
	},
	data() {
		return {
			modRegRefIndex: null,
			reg: null,
		}
	},
	computed: {
		vatNatures() {
			let natures = this.epsonStore.countryVatsNature["IT"];
			if (this.userStore.currBusiness && this.epsonStore.countryVatsNature.hasOwnProperty(this.userStore.currBusiness.country)) {
				natures = this.epsonStore.countryVatsNature[this.userStore.currBusiness.country];
			}
			return natures;
		},
		items() {
			let modIndex = this.modRegRefIndex ?? this.regRefIndex;

			let regRefs = this.vatNatures[this.nature] ?? [];
			let currRegRef = regRefs[modIndex] ?? 0;
			let res = [];

			regRefs.forEach((regRef, index) => {
				res.push({
					title: regRef,
					switch: true,
					active: regRef === currRegRef,
					callback: () => {
						this.modRegRefIndex = index;
						this.reg = regRef;
					}
				});
			});

			return res;
		}
	},
	methods: {
		apply() {
			if(this.modRegRefIndex === null) {
				this.modRegRefIndex = 0;
				this.reg = this.vatNatures[this.nature][0];
			}
			this.$emit('apply', this.modRegRefIndex, this.reg);
		}
	}
}
</script>

<style scoped lang="scss">

</style>